import { render, staticRenderFns } from "./DetailsProduit.vue?vue&type=template&id=ebfb1dac&"
import script from "./DetailsProduit.vue?vue&type=script&lang=js&"
export * from "./DetailsProduit.vue?vue&type=script&lang=js&"
import style0 from "./DetailsProduit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports